import { useReducer } from "react";
import * as Types from "Types";
import { timelineToggle as actions } from "actions";
import { timelineToggle as statuses } from "globalConstants";

export { actions };

export { statuses };

const initialStatus: { status: typeof statuses[keyof typeof statuses] } = {
   status: statuses.fold,
};

function reducer(state = initialStatus, { type, payload }: Types.Reducer) {
   switch (type) {
      case actions.setOpen:
         return {
            ...state,
            status: statuses.open,
         };
      case actions.setFold:
         return {
            ...state,
            status: statuses.fold,
         };
      case actions.toggle:
         return {
            ...state,
            status: state.status === statuses.fold ? statuses.open : statuses.fold,
         };
      default:
         return state;
   }
}

export default function useTimelineToggle(defaultStatus = initialStatus) {
   const [state, dispatch] = useReducer(reducer, defaultStatus);
   return [state, dispatch] as const;
}
